import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getUserProfile = createAsyncThunk(
  "Setting/getUserProfile",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/me/profile`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("Modawla_Dashboard_DT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  "Setting/updateUserProfile",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/admin/me/profile/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: `Bearer ${Cookies.get("Modawla_Dashboard_DT")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

const SettingsSlice = createSlice({
  name: "Setting",
  initialState: {
    isSettingLoading: false,
    error: null,
    ProfileSettingArray: null,
    SettingArray: null,
  },
  extraReducers: (builder) => {
    builder
      // getUserProfile
      .addCase(getUserProfile.pending, (state) => {
        state.isSettingLoading = true;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.isSettingLoading = false;
        state.ProfileSettingArray = action.payload.data;
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        state.isSettingLoading = false;
      })
      // updateUserProfile
      .addCase(updateUserProfile.pending, (state) => {
        state.isSettingLoading = true;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.isSettingLoading = false;
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.isSettingLoading = false;
      });
  },
});

export default SettingsSlice.reducer;
